import React from 'react';
import { FadeIn, Section } from './Shared';
import { ShieldCheck } from 'lucide-react';
export const GuaranteeSection = () => {
  return <Section bg="white" data-id="element-115">
      <FadeIn data-id="element-116">
        <div className="max-w-2xl mx-auto bg-brand-cream border-2 border-brand-yellow/30 rounded-3xl p-6 md:p-10 text-center relative overflow-hidden" data-id="element-117">
          {/* Decorative background shield */}
          <ShieldCheck className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 text-brand-yellow/5 pointer-events-none" data-id="element-118" />

          <div className="relative z-10" data-id="element-119">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-yellow/20 rounded-full mb-4" data-id="element-120">
              <ShieldCheck className="w-10 h-10 text-brand-yellow" data-id="element-121" />
            </div>

            <h2 className="text-3xl font-bold mb-6 font-heading" data-id="element-122">
              Pruébalo durante 14 días.
            </h2>

            <p className="text-xl text-gray-700 mb-6" data-id="element-123">
              Si no notas cambios en tu energía o inflamación…
            </p>

            <div className="bg-white py-4 px-6 rounded-xl inline-block shadow-sm mb-6" data-id="element-124">
              <p className="text-xl font-bold text-brand-teal" data-id="element-125">
                👉 Puedes solicitar reembolso.
              </p>
            </div>

            <p className="text-lg text-gray-500 font-medium uppercase tracking-widest" data-id="element-126">
              Sin preguntas.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};